// No customer identifiers, contact dates, text or credentials leave this module.
// Publishing this metric is best-effort and never delays the exit guard.
export function createNextContactTiming(flow, {
  clock = () => performance.now(),
  publish = sample => {
    try {
      void fetch("/api/crm/next-contact-performance", {
        method:"POST", credentials:"same-origin", keepalive:true,
        headers:{ "Content-Type":"application/json" },
        body:JSON.stringify(sample),
      }).catch(() => {});
    } catch { /* Measurement must never change a confirmed save. */ }
  },
} = {}) {
  const started = clock();
  let cardMs = null, reminderMs = null, reported = false;
  const elapsed = () => Math.max(0, Math.round(clock() - started));
  return {
    cardConfirmed() { cardMs = elapsed(); },
    reminderConfirmed() { reminderMs = elapsed(); },
    finish(outcome) {
      if (reported) return;
      reported = true;
      try {
        publish({ flow, outcome, durationMs:elapsed(), cardMs, reminderMs });
      } catch { /* Diagnostics cannot block a save. */ }
    },
  };
}